// ******** Prestador Profile *********
// app/PrestadorProfile/prestadorprofile.jsx
// ******** autor: WdePaula / Microvolution
// ******** data: 15/07/24
// ******** modificação/melhorias: 22/8/24 | 14h59
// ******** modificação/melhorias: 14/10/24 | 23h59
// ******** modificação/melhorias: 19/10/24 | 21h18
// ******** 24/10/24 | 20h20 | eliminamos várias informações que poluíam o agendamento;
// ******** 12/11/24 | 14h26 | acrescentamos a variável "intervaloAtendimento" que agora vem do servidor;
// ***********************************




import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiaxios from '../../../../Services/apiaxios';
import { getUserInfo } from '../../../../Services/getsaveuserinfo';

import Swal from 'sweetalert2';
import { Spinner } from 'react-bootstrap'; // Você pode usar um spinner de alguma biblioteca de UI, como Bootstrap ou Material-UI

import imgLogomarca from '../../../../Assets/agendex/logoagendexcliente.png';
import imgLogoMini from '../../../../Assets/agendex/iconLogoAgendex.png';
// import imgPlayStore from '../../../../Assets/disponivel/disponivel-android.png';
// import imgDesktop from  '../../../../Assets/disponivel/disponivel-pc.png';
import Footer from '../../components/Footer/footer';
import './prestadorprofile.css';

function PrestadorProfile() {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const { linkPersonalizado } = useParams();
    // const [loading, setLoading] = useState(false);
    const [loadingPrestador, setLoadingPrestador] = useState(false);
    const [loadingFoto, setLoadingFoto] = useState(false);
    const [fotoPerfil, setFotoPerfil] = useState(null);
    const [prestador, setPrestador] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const [userName, setUserName] = useState('');
    const [userFone, setUserFone] = useState('');

    // verifica se é celular, tablet, NB ou PC, etc
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Carregar dados do cliente (nome/ceular) do localStorage quando o componente monta
    useEffect(() => {
        const userInfo = getUserInfo();
        if (userInfo) {
            setUserName(userInfo.nome);
            setUserFone(userInfo.celular);

        if (userName && userFone) {
            Swal.fire({
                title: 'Seja bem-vindo(a) de volta!',
                text: `Que bom que você "${userName}" está de volta para realizar um novo agendamento!`,
                icon: 'success',
                confirmButtonText: 'Continuar'
            });
        };
        
        }
    }, [userName]);
    
    // verifica se mudou o link-personalizado e carrega os dados-base do prestador
    useEffect(() => {
        fetchPrestador();
    }, [linkPersonalizado]);

    // carrega os dados-base do prestador
    const fetchPrestador = async () => {
        try {
            setLoadingPrestador(true);
            const response = await apiaxios.get(`/empresa/link`, {
                params: { link: linkPersonalizado, tipoApp: 0 }
                }
            );

            // Tratando o status code
            if (response.status === 200) {
                if (Array.isArray(response.data) && response.data.length > 0) {
                    setPrestador(response.data[0]); // Setando o prestador como o primeiro elemento do array
                    // console.log('response.data dentro empresa/link ', response.data);
                } else {
                    setError('Prestador não encontrado.');
                }
            } else {
                const errorMessage = response.data.retorno || 'Erro desconhecido';
                setError(errorMessage);
                Swal.fire('Erro', errorMessage, 'error');
            }            
        } catch (error) {
            // Verifica se error.response.data é uma string JSON e a converte para objeto
            let errorData;
            if (typeof error.response.data === 'string') {
                try {
                    errorData = JSON.parse(error.response.data); // Converte a string em objeto
                } catch (parseError) {
                    console.error('Erro ao fazer parse da string JSON: ', parseError);
                    errorData = null; // Define como null se o JSON for inválido
                }
            } else {
                errorData = error.response.data; // Já é um objeto
            }

            if (errorData && errorData.retorno) {
                const errorMessage = errorData.retorno || 'Erro desconhecido';
                // console.log(errorMessage);
                setError(errorMessage);
                Swal.fire('Erro', errorMessage, 'error');
            } else {
                setError('Prestador não encontrado ou erro na requisição.');
                Swal.fire('Erro', 'Prestador não encontrado ou erro na requisição.', 'error');
            }
        } finally {
            setLoadingPrestador(false);
        }
    };

    useEffect(() => {
        if (prestador && prestador.ID_EMPRESA) {
            fetchPrestadorFoto(prestador);
        }
    }, [prestador]);

    const fetchPrestadorFoto = async (prestador) => {
        if (prestador && prestador.ID_EMPRESA) {
            const url = `/empresa/CarregaFotoPerfilWeb?id_empresa=${prestador.ID_EMPRESA}`;
            setLoadingFoto(true);
            try {
                const response = await apiaxios.get(url, { skipErrorHandler: true });
                if (response.data.retorno === "OK" && response.data.foto) {
                    setFotoPerfil(`data:image/jpeg;base64,${response.data.foto}`);
                }
            } catch (error) {
                // handleApiError(error);
                console.error(error.response.data.retorno);
            } finally {
                setLoadingFoto(false);
            }
        }
    };

    if (error) {
        return <div>{error}</div>;
    }

    if (!prestador) {
        return <div>Carregando...</div>;
    }

    const CarregaEmpresa = (id_empresa, nomePrestador, enderecoPrestador, fotoPrestador, celularPrestador, tipoAtendimento, intervaloAtendimento) => {
        if (parseInt(tipoAtendimento, 10) === 1) {
            navigate(`/agendar/${linkPersonalizado}/${id_empresa}/profissionais`, { 
                state: { 
                    nomePrestador, 
                    enderecoPrestador, 
                    celularPrestador, 
                    fotoPrestador, 
                    intervaloAtendimento
                } 
            });
        } else {
            navigate(`/agendar/${linkPersonalizado}/${id_empresa}/servico`, { 
                state: { 
                    nomePrestador, 
                    enderecoPrestador, 
                    fotoPrestador, 
                    celularPrestador,
                    intervaloAtendimento
                } 
            });
        }
    };

    const handleClickAndroid = (e) => {
        // alert('android mobile');
        e.preventDefault();
        e.stopPropagation();
        window.open('https://play.google.com/store/apps/details?id=br.net.wmx.AgendexCliente', '_blank');
    };
    const handleClickDesktop = (e) => {
        // alert('desktop PC');
        e.preventDefault();
        e.stopPropagation();
        window.open('https://drive.google.com/file/d/1tQfDQKIgG2RB8zSFchp0nn3KSM3y70KC/view?pli=1', '_blank');
    };
    const handleClickIndicar = (e) => {
        // alert('desktop PC');
        e.preventDefault();
        e.stopPropagation();
        window.open(`https://wa.me/5531995525753?text=${whatsappMessageIndicar}`, '_blank');
    };
    // Construir a mensagem personalizada para WhatsApp
    const whatsappMessageIndicar = encodeURIComponent(`
        Olá, gostaria de gostaria de indicar um estabelecimento para fazer parte do Agendex.\n
        Pode me passar mais informações?
    `);
    
    const handleClickFaleConosco = (e) => {
        // alert('desktop PC');
        e.preventDefault();
        e.stopPropagation();
        window.open(`https://wa.me/5531995525753?text=${whatsappMessageFaleConosco}`, '_blank');
    };
    // Construir a mensagem personalizada para WhatsApp
    const whatsappMessageFaleConosco = encodeURIComponent(`
        Olá, gostaria de gostaria de sugerir, criticar, elogiar ou relatar algum problema no Agendex.
    `);

    const handleSobreClick = () => {
        Swal.fire({
            toast: true,
            position: 'top-end',
            showConfirmButton: true,
            icon: 'info',
            title: 'Agendex® Web. Version 1.0.9. Copyright © 2021-2025',
            text: '(c)Agendex. All-in-one. Minha Agenda. Agenda Profissional.  Microvolution Informática, by WMX Group. All Rights Reserved. Todos os Direitos Reservados. (04/10/25)'
        });
    };



    return (
        <>
            <div className="container-fluid">
                <div className="text-right">
                    <div className="dropdown">
                        <button className="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <i className="bi bi-three-dots-vertical fs-5"></i>
                        </button>
                        <ul className="dropdown-menu text-right">
                            <li><button onClick={handleClickAndroid} className="dropdown-item" type="button">App Android</button></li>
                            <li><button onClick={handleClickDesktop} className="dropdown-item" type="button">Versão Windows</button></li>
                            <li><button onClick={handleClickIndicar} className="dropdown-item" type="button">Indique e ganhe</button></li>
                            <li><button onClick={handleClickFaleConosco} className="dropdown-item" type="button">Informe um problema</button></li>
                            <li><button onClick={handleSobreClick} className="dropdown-item" type="button">Sobre</button></li>
                        </ul>
                    </div>
                </div>
                <div className="row flex-nowrap">
                    <div className="col py-3 me-3 text-center">
                        <img src={isMobile ? imgLogoMini : imgLogomarca} className="img-logo" alt="logo agendex"/>
                        <br/>
                        <h5>Agendamento on-line em Salões de Beleza, Barbearias, Esmalterias, Petshops, Lava-jato, Clínicas, etc</h5>
                        {/* Verifique se o loading está ativo */}
                        {loadingFoto ? (
                            <div className="text-center">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Carregando...</span>
                                </Spinner>
                            </div>
                            ) : (
                            // Renderiza o conteúdo normalmente
                            <div className="col py-3 me-3">
                                <div className="img-usuario text-center">
                                    <img src={fotoPerfil} className="usuario-foto" alt={prestador.NOME}/>
                                </div>
                            </div>
                        )}

                        <div className="box-explorarempresas">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Nome Empresa</th>
                                        <th>Endereço</th>
                                        <th className="text-right">Fone</th>
                                    </tr>
                                </thead>  
                                <tbody>
                                    <tr key={prestador.ID_EMPRESA}>
                                        <td data-label="Nome Empresa">{prestador.NOME}</td>
                                        <td data-label="Endereço:">{prestador.ENDERECO} - {prestador.BAIRRO} - {prestador.CIDADE}</td>
                                        <td className="text-right" data-label="Fone:">{prestador.CELULAR}</td>
                                        {/* <td className="text-right" data-label="Fone:">{prestador.FONE}</td> // modificado pela linha acima */}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div className='text-center'>
                    <button
                        className="btn btn-success btn-lg mt-10"
                        type="button"
                        onClick={() => 
                            CarregaEmpresa(
                            prestador.ID_EMPRESA, prestador.NOME, prestador.ENDERECO + ' - ' + prestador.BAIRRO + ' - ' + prestador.CIDADE, fotoPerfil, prestador.CELULAR, prestador.TIPOATENDIMENTO, prestador.TEMPOAGENDAMINUTOS // repassa agora o tempoAgendaMinutos para as páginas seguitnes 12/11/24w
                        )}
                    >
                        <i className="bi bi-clock-history"></i> AGENDAR
                    </button>
                </div>
            </div>
            <Footer/>
        </>
    );    
}

export default PrestadorProfile;